export const INITIALIZE_NEW_GAME = "INITIALIZE_NEW_GAME";

export const FETCH_BREEDS = "FETCH_DOGGOS";

export const SET_BREEDS = "FETCH_DOGGOS";

export const START_NEW_GAME = "START_NEW_GAME";

export const SET_PAIRS = "SET_PAIRS";

export const SET_SETTINGS = "SET_SETTINGS";

export const SET_NEXT_PLAYER = "SET_NEXT_PLAYER";

export const SET_EMPTY_SCORES = "SET_EMPTY_SCORES";

export const INCREASE_CURRENT_PLAYER_SCORE = "INCREASE_CURRENT_PLAYER_SCORE";

export const FETCH_DOGGOS = "FETCH_DOGGOS";

export const PREPARE_PAIRS = "PREPARE_PAIRS";

export const SET_USER_SCORE = "SET_USER_SCORE";

export const SET_CURRENT_USER = "SET_CURRENT_USER";

export const SET_MATCHED_PAIR = "SET_MATCHED_PAIR";
